import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "public": {
      "column": {
        "default": "0",
        "name": "public",
        "null": false,
        "type": "boolean"
      },
      "name": "public",
      "selected_by_default": null,
      "translated": false
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "BrainBreak",
  "collectionKey": "brain_breaks",
  "collectionName": "brain_breaks",
  "i18nKey": "brain_break",
  "camelizedLower": "brainBreak",
  "name": "BrainBreak",
  "nameDasherized": "brain-break",
  "pluralName": "brain_breaks",
  "ransackable_associations": [
    {
      "className": "BrainBreak::Audit",
      "collectionName": "brain_break_audits",
      "foreignKey": "brain_break_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "BrainBreakAudit",
      "through": null
    },
    {
      "className": "BrainBreakClassStep",
      "collectionName": "brain_break_class_steps",
      "foreignKey": "brain_break_id",
      "name": "brain_break_class_steps",
      "macro": "has_many",
      "resource_name": "BrainBreakClassStep",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "brain_break_class_steps"
    },
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "BrainBreak::Audit",
      "collectionName": "brain_break_audits",
      "foreignKey": "brain_break_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "BrainBreakAudit",
      "through": null
    },
    {
      "className": "BrainBreak::Translation",
      "collectionName": null,
      "foreignKey": "brain_break_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SchoolClassBrainBreak",
      "collectionName": "school_class_brain_breaks",
      "foreignKey": "brain_break_id",
      "name": "school_class_brain_breaks",
      "macro": "has_many",
      "resource_name": "SchoolClassBrainBreak",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "BrainBreak::Translation",
      "collectionName": null,
      "foreignKey": "brain_break_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "course_id",
      "column": {
        "default": null,
        "name": "course_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "public",
      "column": {
        "default": "0",
        "name": "public",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "BrainBreakClassStep",
      "collectionName": "brain_break_class_steps",
      "foreignKey": "brain_break_id",
      "name": "brain_break_class_steps",
      "macro": "has_many",
      "resource_name": "BrainBreakClassStep",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    }
  ],
  "paramKey": "brain_break",
  "primaryKey": "id"
}

/** Frontend model for BrainBreak. */
class BrainBreak extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  public() {
    return this.readAttributeUnderscore("public")
  }

  /** @returns {boolean} */
  hasPublic() {
    const value = this.public()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./brain-break-class-step.js").default>} */
  brainBreakClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("BrainBreakClassStep")

    const ransack = {}

    ransack["brain_break_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "brain_break_class_steps",
        model: this,
        modelName: "BrainBreakClassStep",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./brain-break-class-step.js").default>>} */
  loadBrainBreakClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("BrainBreakClassStep")

    const ransack = {}

    ransack["brain_break_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "brain_break_class_steps",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const modelClass = modelClassRequire("Survey")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "survey", model: this, modelClass},
      {ransack}
    )
  }
}

export default BrainBreak
